module.exports = __webpack_public_path__ + "static/img/8.a68b1776.png";